import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  closeSelectedCommentPop,
  openCommentPop,
  deleteComment,
  reportPlaceComment,
} from '@app-core/place/actions'
import { openConfirmDialog } from '@app-core/app/actions'
import SelectedCommentPop from './components/SelectedCommentPop'

class PlaceSelectedCommentPopContainer extends PureComponent {
  _editComment = () => {
    const { commentId, openCommentPop, closeSelectedCommentPop, place } = this.props
    closeSelectedCommentPop()
    openCommentPop({ commentId, via: 'edit', place: place.toJS() })
  }

  _deleteComment = () => {
    const { comment, closeSelectedCommentPop, deleteComment } = this.props
    closeSelectedCommentPop()
    deleteComment({ comment: comment.toJS() })
  }

  _reportComment = () => {
    const { comment, reportPlaceComment, place } = this.props
    reportPlaceComment({ comment, place: place.toJS() })
  }

  render() {
    const {
      isPopOpen,
      isCurrentUserComment,
      closeSelectedCommentPop,
      openConfirmDialog,
    } = this.props
    return (
      <SelectedCommentPop
        isOpen={isPopOpen}
        isCurrentUserComment={isCurrentUserComment}
        openConfirmDialog={openConfirmDialog}
        onClickEdit={this._editComment}
        onClickDelete={this._deleteComment}
        onClickReport={this._reportComment}
        onClose={closeSelectedCommentPop}
      />
    )
  }
}

function mapStateToProps(state) {
  const placeId = state.place.get('placeId')
  const commentId = state.place.get('selectedCommentId')
  const comment = state.place.getIn(['comments', commentId])
  const userId = state.currentUser.getIn(['userInfo', 'uid'])
  const isCurrentUserComment = commentId ? comment.getIn(['userInfo', 'mid']) === userId : false

  return {
    isPopOpen: state.place.get('isSelectedCommentPopOpen'),
    isCurrentUserComment,
    commentId,
    comment,
    place: state.place.getIn(['places', placeId]),
  }
}

export default connect(mapStateToProps, {
  openCommentPop,
  closeSelectedCommentPop,
  deleteComment,
  reportPlaceComment,
  openConfirmDialog,
})(PlaceSelectedCommentPopContainer)
